import { FunctionComponent } from 'react'

import { Box } from 'native-base'
import Svg, { G, Path, Defs, ClipPath, Rect } from 'react-native-svg'

type ChasingMoneyIllustrationProps = {
  maxH?: number
  width?: number
  height?: number
}

export const ChasingMoneyIllustration: FunctionComponent<ChasingMoneyIllustrationProps> = ({
  maxH = 250,
  width = 251,
  height = 250
}) => (
  <Box {...{ maxH }}>
    <Svg width={width} height={height} viewBox="0 0 251 250" fill="none">
      <G clipPath="url(#clip0_8483_162413)">
        <Path
          d="M101.56 172.66C139.717 172.66 170.65 141.727 170.65 103.57C170.65 65.4126 139.717 34.48 101.56 34.48C63.4026 34.48 32.47 65.4126 32.47 103.57C32.47 141.727 63.4026 172.66 101.56 172.66Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M215.27 90.3201L214.35 91.4401C214.35 91.4401 220.31 96.7301 221.17 98.2101L222.67 96.7301C222.67 96.7301 215.55 90.6801 215.28 90.3101L215.27 90.3201Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M222.95 100.18L197.11 129.37C196.91 129.6 196.7 129.82 196.48 130.02C196.3 130.2 196.11 130.37 195.91 130.53C195.81 130.61 195.71 130.7 195.61 130.77C195.32 131 195.02 131.21 194.72 131.4C194.59 131.49 194.47 131.57 194.34 131.64C193 132.42 191.51 132.91 189.95 133.07C187.19 133.35 184.43 132.59 182.2 130.94C175.23 125.72 169.61 120.14 166.26 114.53C166.26 114.52 166.26 114.52 166.26 114.51C163.72 119.82 161.57 123.76 160.02 126.76L160.04 126.78C164.03 131.5 167.08 137.26 169.78 143.68C170 144.22 170.22 144.76 170.45 145.3C170.89 146.39 171.33 147.49 171.75 148.6C171.96 149.16 172.18 149.72 172.39 150.29C173.71 153.82 175 157.5 176.33 161.28C176.54 161.9 176.76 162.52 176.98 163.14C176.98 163.14 176.983 163.147 176.99 163.16C176.78 163.31 176.57 163.46 176.36 163.61C176.31 163.65 176.25 163.69 176.2 163.72C175.95 163.9 175.7 164.09 175.44 164.26C175.35 164.32 175.27 164.39 175.18 164.45C175.05 164.55 174.91 164.65 174.77 164.75C174.41 164.99 174.05 165.22 173.68 165.44C173.32 165.66 172.95 165.88 172.58 166.1C171.3 166.85 169.98 167.52 168.62 168.1C168.05 168.36 167.48 168.6 166.89 168.81C166.63 168.93 166.36 169.03 166.09 169.12C165.19 169.45 164.27 169.74 163.34 170L142.92 134C141.84 132.08 141.36 129.88 141.51 127.68C142.36 115.54 144.33 103.53 147.4 91.76C149.09 91.02 150.85 90.12 152.53 89.1C155.35 87.4 157.95 85.37 159.63 83.26C159.65 83.27 159.67 83.27 159.69 83.28C163.51 84.39 171.59 84.74 178.62 96.1C178.74 96.3 178.86 96.5 178.98 96.7C179.34 97.3 179.69 97.93 180.05 98.59C180.06 98.6 180.06 98.61 180.06 98.62C180.29 99.06 180.53 99.52 180.76 100C183.03 104.68 185.97 109 189.51 112.8L189.53 112.82C189.53 112.82 189.54 112.8 189.55 112.79C192.29 108.37 196.52 103.84 200.57 99.99C206.52 94.37 212.1 90.26 212.1 90.26C212.62 90.59 213.13 90.92 213.64 91.27C213.75 91.35 213.87 91.43 213.98 91.51C214.04 91.54 214.11 91.59 214.17 91.64C214.39 91.79 214.6 91.95 214.81 92.11C214.92 92.19 215.03 92.28 215.14 92.36C215.34 92.51 215.53 92.66 215.73 92.82C216.05 93.07 216.36 93.32 216.67 93.59C217.08 93.93 217.49 94.29 217.89 94.65C217.93 94.69 217.97 94.73 218.01 94.75C218.31 95.04 218.61 95.32 218.9 95.61C218.98 95.69 219.06 95.77 219.14 95.85L219.3 96.01C219.84 96.54 220.35 97.08 220.84 97.64C221.02 97.83 221.19 98.02 221.35 98.21C221.49 98.37 221.64 98.54 221.78 98.71C221.79 98.72 221.79 98.73 221.8 98.74C222.12 99.12 222.43 99.51 222.73 99.9C222.8 99.99 222.88 100.09 222.95 100.18Z"
          fill="#F3123C"
        />
        <Path
          d="M93.8001 48.5401H93.7901L82.5901 52.5501C81.7401 51.8301 81.2301 51.5501 80.9501 51.5501H80.9401C80.9401 51.5501 80.8501 51.5501 80.8201 51.5801C80.5401 51.7101 80.7001 52.3801 80.9601 53.1501H80.9301L68.6901 57.5401H68.6601C68.1101 57.5601 67.6301 57.5801 67.2301 57.6101C67.1201 57.6101 67.0201 57.6101 66.9201 57.6401C66.7401 57.6701 66.5801 57.6901 66.4301 57.7201H66.4101C65.5401 57.9001 65.2601 58.1901 65.5101 58.5601C65.5101 58.5601 65.5134 58.5635 65.5201 58.5701C65.5201 58.5701 65.5701 58.6301 65.6001 58.6601H65.5901L63.7401 59.3301L62.8701 55.2601L62.2901 52.5601L42.8201 42.5601L43.9301 39.9201L60.8401 45.8601H60.8501V45.8301L58.1601 33.3001L81.6401 24.8901L84.6601 30.7601L90.4501 42.0201L93.8001 48.5401Z"
          fill="#F3123C"
        />
        <Path
          d="M139.03 59.6101C138.86 60.0301 138.69 60.4501 138.51 60.8701C138.38 61.1601 138.25 61.4501 138.11 61.7401C137.52 61.6401 137.03 61.5101 136.61 61.3601C136.51 61.3201 136.41 61.2801 136.31 61.2401C136.22 61.2001 136.13 61.1601 136.05 61.1201C135.96 61.0701 135.88 61.0301 135.81 60.9801C135.73 60.9301 135.66 60.8801 135.6 60.8301C135.54 60.7801 135.48 60.7301 135.42 60.6701C135.36 60.6201 135.31 60.5601 135.26 60.5001C135.21 60.4401 135.17 60.3801 135.13 60.3101C135.03 60.1501 134.96 59.9701 134.92 59.7701C134.9 59.7201 134.89 59.6801 134.89 59.6301C134.89 59.6201 134.88 59.6001 134.88 59.5901V59.5601C134.9 59.6201 134.92 59.6601 134.94 59.7101C134.96 59.7601 135 59.8001 135.03 59.8401C135.07 59.8801 135.1 59.9201 135.15 59.9501C135.23 60.0101 135.34 60.0501 135.46 60.0901C135.66 60.1501 135.9 60.1701 136.17 60.1701C136.34 60.1701 136.53 60.1601 136.73 60.1301H136.79C136.99 60.1001 137.21 60.0701 137.44 60.0201C137.81 59.9401 138.21 59.8401 138.62 59.7301C138.75 59.7001 138.88 59.6601 139.01 59.6201C139.01 59.6201 139.02 59.6201 139.03 59.6201V59.6101Z"
          fill="#404040"
        />
        <Path
          d="M166.46 75.3C166.06 76.32 165.46 77.25 164.69 78.04C164.44 78.3 164.17 78.55 163.88 78.78C163.31 79.24 162.68 79.62 162.02 79.92C161.36 80.22 160.66 80.43 159.93 80.55C158.94 80.76 157.93 80.83 156.93 80.76C155.96 80.7 154.98 80.51 154.05 80.18C153.97 80.16 153.89 80.12 153.8 80.09C153.72 80.05 153.64 80.02 153.56 79.99C153.06 79.79 152.57 79.55 152.1 79.28C151.4 78.87 150.75 78.38 150.16 77.83C149.57 77.28 149.04 76.66 148.58 75.99C147.89 75.06 147.24 74.11 146.63 73.13C143.28 67.88 141.01 62.01 139.94 55.86C142.1 54.36 141.47 52.58 140.43 52.86C140.38 52.88 140.32 52.9 140.27 52.92C140.16 52.97 140.04 53.04 139.92 53.15C139.87 53.19 139.81 53.25 139.75 53.31C139.71 53.36 139.68 53.39 139.64 53.42C139.61 53.44 139.58 53.47 139.56 53.48C139.55 53.49 139.55 53.5 139.54 53.5C139.53 53.5 139.52 53.51 139.5 53.51C139.48 53.52 139.47 53.53 139.45 53.53C139.38 53.56 139.33 53.54 139.29 53.5C139.26 53.47 139.24 53.43 139.22 53.38C139.08 53 139.2 52.04 139.49 51.25C138.89 51.08 138.27 51.03 137.66 51.11C137.66 51.11 140.08 43.17 151.14 49.8C156.89 53.24 153.21 59.65 153.21 59.65C153.21 59.65 153.98 59.82 155.16 60.19C155.31 60.24 155.48 60.29 155.65 60.35C155.82 60.4 156 60.46 156.18 60.53C156.73 60.72 157.32 60.95 157.95 61.21C158.26 61.34 158.58 61.48 158.9 61.63C159.23 61.78 159.55 61.94 159.88 62.11C160.43 62.39 160.98 62.7 161.52 63.04C161.95 63.31 162.37 63.59 162.78 63.9C163.09 64.13 163.39 64.37 163.68 64.62C163.87 64.79 164.06 64.96 164.24 65.14C164.34 65.23 164.43 65.32 164.51 65.41C166.83 67.8 168.12 71.03 166.46 75.3Z"
          fill="#404040"
        />
        <Path
          d="M137.66 85.6101C137.45 85.4501 137.24 85.29 137.04 85.12C135.41 83.82 134.03 82.6201 133.1 81.7901C132.81 81.5301 132.52 81.27 132.25 81.01C132.1 80.88 131.95 80.74 131.81 80.6C132.54 80.12 133.25 79.6 133.93 79.05L137.66 85.6101Z"
          fill="#404040"
        />
        <Path
          d="M177.38 197.42C173.75 191.72 171.4 186.92 168.95 174.08L167.62 171.73C168.28 171.25 168.95 170.8 169.64 170.35C171.69 169.04 173.86 167.89 176.1 166.93C176.1 166.93 176.1 166.94 176.11 166.94C176.39 167.38 176.69 167.83 177.03 168.31C177.75 169.33 178.63 170.52 179.85 172.27C180.68 177.02 179.52 192.01 177.38 197.42Z"
          fill="#404040"
        />
        <Path
          d="M219.27 84.9902C217.42 87.5302 216.36 88.9502 215.36 90.2202C217.53 92.6402 220.02 94.8502 222.66 96.7402L224.51 94.7202C235.86 88.2402 239.66 84.4702 243.86 79.2002C238.02 78.9302 223.48 82.6602 219.26 84.9902H219.27Z"
          fill="#404040"
        />
        <Path
          d="M146.69 73.1601L146.63 73.1301"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M136.88 64.5801C136.81 64.5701 136.75 64.56 136.68 64.55"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M115.16 74.3101C113.92 75.2101 112.63 76.2001 111.28 77.2701"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M159.62 83.2302C157.94 85.3402 155.34 87.3802 152.52 89.1002C150.84 90.1202 149.08 91.0202 147.39 91.7602C144.44 90.5402 140.89 88.1202 137.66 85.6102L133.93 79.0502C133.25 79.6002 132.54 80.1202 131.81 80.6002C127.68 83.4202 123.38 86.0102 118.95 88.3502C113.37 91.0002 110.19 89.2202 104.34 85.0402C100.75 82.4802 95.9501 79.0302 92.5701 76.5902C93.4801 71.6502 96.2201 67.2402 100.23 64.2102C108.51 69.7702 114.11 73.5902 115.16 74.3102C119.92 70.7802 123.86 68.3502 127.12 66.7902C131.37 64.7502 134.45 64.1702 136.68 64.5502C136.65 64.6102 136.61 64.6702 136.58 64.7302C137.42 64.8902 138.15 65.1902 138.78 65.5902C142.11 67.7002 144.35 72.0902 146.63 73.1302C147.24 74.1102 147.89 75.0602 148.58 75.9902C149.04 76.6602 149.57 77.2802 150.16 77.8302C150.75 78.3802 151.4 78.8702 152.1 79.2802C152.57 79.5602 153.06 79.8002 153.56 80.0002C153.64 80.0302 153.72 80.0602 153.8 80.0902C153.89 80.1202 153.97 80.1602 154.05 80.1802C154.98 80.5102 155.96 80.7002 156.93 80.7602C157.75 81.5602 158.72 82.5202 159.62 83.2302Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M159.8 83.3702L159.68 83.2802C159.68 83.2802 159.64 83.2502 159.62 83.2302"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M156.93 80.7601L156.82 80.6501"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M166.46 75.3C166.06 76.32 165.46 77.25 164.69 78.04C164.45 78.31 164.17 78.56 163.88 78.79C163.31 79.25 162.68 79.63 162.02 79.92C161.36 80.22 160.66 80.43 159.93 80.55C158.94 80.76 157.93 80.83 156.93 80.76C155.96 80.7 154.98 80.51 154.05 80.18C153.97 80.16 153.89 80.12 153.8 80.09C153.72 80.06 153.64 80.03 153.56 80C153.06 79.8 152.57 79.56 152.1 79.28C151.4 78.87 150.75 78.38 150.16 77.83C149.57 77.28 149.04 76.66 148.58 75.99C147.89 75.06 147.24 74.11 146.63 73.13C143.28 67.88 141.01 62.01 139.94 55.86C142.1 54.36 141.47 52.58 140.43 52.86C140.38 52.88 140.32 52.9 140.27 52.92C140.16 52.97 140.04 53.05 139.92 53.15L139.75 53.32C139.75 53.32 139.68 53.39 139.64 53.42C139.61 53.45 139.58 53.47 139.56 53.48C139.55 53.49 139.55 53.5 139.54 53.5C139.53 53.5 139.53 53.51 139.52 53.51C139.52 53.51 139.51 53.52 139.5 53.52C139.48 53.53 139.47 53.53 139.45 53.53C139.38 53.56 139.33 53.54 139.29 53.5C139.26 53.47 139.24 53.43 139.22 53.38C139.08 53 139.2 52.04 139.49 51.25C138.89 51.08 138.27 51.03 137.66 51.11C137.66 51.11 140.08 43.17 151.14 49.8C156.89 53.24 153.21 59.65 153.21 59.65C153.21 59.65 153.98 59.82 155.16 60.19C155.31 60.24 155.48 60.29 155.65 60.35C155.82 60.4 156 60.46 156.18 60.53C156.73 60.72 157.32 60.95 157.95 61.21C158.26 61.34 158.58 61.48 158.9 61.63C159.23 61.78 159.55 61.94 159.88 62.11C160.43 62.39 160.98 62.7 161.52 63.04C161.95 63.31 162.37 63.59 162.78 63.9C163.09 64.13 163.39 64.37 163.68 64.62C163.87 64.79 164.06 64.96 164.24 65.14C164.34 65.23 164.43 65.32 164.51 65.41C166.83 67.8 168.12 71.03 166.46 75.3V75.3Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M146.63 73.1302C144.35 72.0902 142.11 67.7002 138.78 65.5902C138.15 65.1902 137.42 64.8902 136.58 64.7302C136.61 64.6702 136.65 64.6102 136.68 64.5502C137.2 63.6402 137.68 62.7002 138.11 61.7402C138.25 61.4502 138.38 61.1602 138.51 60.8702C138.69 60.4502 138.86 60.0302 139.03 59.6102H139.01C138.88 59.6502 138.75 59.6902 138.62 59.7302C138.21 59.8402 137.81 59.9402 137.44 60.0202C137.21 60.0702 136.99 60.1002 136.79 60.1302H136.73C136.53 60.1602 136.34 60.1702 136.17 60.1702C135.9 60.1702 135.66 60.1502 135.46 60.0902C135.34 60.0502 135.23 60.0102 135.15 59.9502C135.1 59.9202 135.07 59.8802 135.03 59.8402C134.99 59.8002 134.96 59.7602 134.94 59.7102C134.92 59.6602 134.9 59.6202 134.88 59.5602C134.77 58.7702 135.02 57.7502 135.52 56.3902C136.02 54.9902 136.78 53.2702 137.66 51.1102C138.27 51.0302 138.89 51.0802 139.49 51.2502C139.2 52.0402 139.08 53.0002 139.22 53.3802C139.23 53.4302 139.26 53.4702 139.29 53.5002C139.33 53.5402 139.38 53.5602 139.45 53.5302C139.47 53.5302 139.48 53.5302 139.5 53.5202C139.5 53.5202 139.51 53.5202 139.52 53.5102C139.52 53.5102 139.52 53.5002 139.54 53.5002C139.56 53.5002 139.55 53.5002 139.56 53.4802C139.58 53.4702 139.61 53.4402 139.64 53.4202C139.68 53.3902 139.71 53.3602 139.75 53.3202L139.92 53.1502C140.04 53.0502 140.16 52.9702 140.27 52.9202C140.32 52.9002 140.38 52.8802 140.43 52.8602C141.47 52.5802 142.1 54.3602 139.94 55.8602C141.01 62.0102 143.28 67.8802 146.63 73.1302Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M135.03 59.8401C135.03 59.8401 134.96 59.7601 134.94 59.7101C134.91 59.6901 134.9 59.6601 134.89 59.6301"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M134.88 59.59C134.88 59.59 134.86 59.56 134.86 59.54"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M139.01 59.6101C138.85 60.0401 138.68 60.4601 138.51 60.8701"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M136.58 64.7302L136.57 64.7402"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M110.47 40.2802C107.03 42.9902 104.5 46.6602 103.19 50.8302C100.69 49.0302 99.0601 47.8502 99.0601 47.8502C99.2101 47.2802 99.3801 46.7202 99.5701 46.1902C100.79 42.6902 102.7 39.9902 105.34 38.1502C105.71 37.8902 106.09 37.6502 106.49 37.4302C106.49 37.4302 108.03 38.5502 110.48 40.2802H110.47Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M138.11 61.74C137.68 62.7 137.2 63.64 136.68 64.55C134.45 64.17 131.37 64.75 127.12 66.79C121.6 63.84 109.51 55.35 103.18 50.83C104.49 46.66 107.02 42.99 110.46 40.29C116.41 44.48 127.81 52.29 135.52 56.39C135.02 57.75 134.77 58.77 134.88 59.56V59.59C134.88 59.59 134.89 59.62 134.89 59.63C134.89 59.68 134.9 59.72 134.92 59.77C134.96 59.97 135.03 60.15 135.13 60.31C135.17 60.38 135.21 60.44 135.26 60.5C135.31 60.56 135.36 60.62 135.42 60.67C135.48 60.73 135.54 60.78 135.6 60.83C135.66 60.88 135.73 60.93 135.81 60.98C135.88 61.03 135.96 61.07 136.05 61.12C136.13 61.16 136.22 61.2 136.31 61.24C136.41 61.28 136.51 61.32 136.61 61.36C137.03 61.51 137.52 61.64 138.11 61.74Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M135.64 56.4601C135.64 56.4601 135.56 56.4201 135.52 56.3901"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M110.46 40.2902C110.46 40.2902 110.4 40.2402 110.37 40.2202"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M127.24 66.86C127.24 66.86 127.16 66.82 127.12 66.79"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M166.27 114.48C169.62 120.1 175.25 125.69 182.23 130.91C184.45 132.57 187.22 133.33 189.98 133.04C192.74 132.75 195.29 131.44 197.12 129.37L222.96 100.19C219.96 96.2602 216.29 92.8902 212.11 90.2402C212.11 90.2402 191.1 105.72 187.13 117.69"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M189.63 112.9C189.63 112.9 189.56 112.83 189.54 112.79C189.52 112.79 189.52 112.78 189.52 112.77C186.02 108.99 182.99 104.61 180.75 99.9802C173.27 84.7102 163.8 84.4702 159.62 83.2302"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M147.39 91.76C144.32 103.53 142.35 115.54 141.5 127.68C141.35 129.88 141.83 132.08 142.91 134L163.33 169.98C165.74 169.31 168.07 168.41 170.3 167.31C171.84 166.55 173.33 165.69 174.75 164.74C175.51 164.24 176.25 163.7 176.97 163.14L176.31 161.28C174.98 157.5 173.69 153.82 172.37 150.29C168.98 141.24 165.34 133.16 159.98 126.86"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M158.34 130.27C159.64 127.23 162.79 121.72 165.46 116.21C174.39 97.8202 169.21 93.8702 167.71 91.9702"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M115.34 74.4301L115.16 74.3101"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.23 64.2102C100.11 64.1302 100 64.0502 99.8801 63.9702"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M147.48 91.7402C147.48 91.7402 147.4 91.7602 147.39 91.7602"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M137.66 85.6101C137.45 85.4501 137.24 85.2901 137.04 85.1201C135.61 84.0101 134.27 82.8601 133.1 81.7901C132.81 81.5301 132.52 81.2701 132.25 81.0101C132.1 80.8801 131.95 80.7401 131.81 80.6001"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M92.5702 76.59C92.4302 76.49 92.2902 76.39 92.1602 76.3"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.12 29.4701C99.6201 28.8801 99.2401 28.4401 98.7701 27.8801C98.5401 27.5901 98.2101 27.3901 97.8401 27.3401C97.4701 27.2901 97.1001 27.3801 96.8001 27.6001C96.5001 27.8201 96.3001 28.1501 96.2401 28.5101C96.1801 28.8801 96.2601 29.2501 96.4701 29.5601C96.9901 30.2401 97.5601 30.8801 98.1601 31.4901"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M99.3801 33.5002V33.4902"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M91.35 37.1401C91.35 37.1401 90.88 40.8601 99.55 46.1901"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M84.49 31.0401C86.84 26.8101 92.31 22.6401 97.17 25.3201C97.94 25.7501 98.59 26.3601 99.1 27.0801C99.6 27.8001 99.93 28.6301 100.07 29.5001"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M62.2601 52.5002L42.8101 42.5502L43.9301 39.9102L60.8401 45.8202"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M68.6501 57.5401L80.9301 53.1501"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.5901 52.5501L93.8001 48.5601L81.6401 24.8901L58.1301 33.3001L63.7301 59.3001L65.5601 58.6601"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M176.12 166.93H176.11H176.1C173.86 167.89 171.69 169.04 169.64 170.35C168.95 170.8 168.28 171.25 167.62 171.73C167.61 171.73 167.61 171.73 167.6 171.75L166.08 169.12C166.35 169.03 166.62 168.93 166.88 168.81C167.47 168.6 168.04 168.36 168.61 168.1C169.97 167.52 171.29 166.85 172.57 166.1C172.94 165.9 173.31 165.68 173.67 165.44C174.04 165.22 174.4 164.99 174.76 164.75C175.2 165.48 175.66 166.21 176.12 166.93Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M174.73 164.7C174.73 164.7 174.75 164.73 174.75 164.74C174.76 164.74 174.76 164.75 174.76 164.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M176.12 166.93C176.42 167.4 176.72 167.86 177.03 168.31C177.93 169.66 178.87 170.98 179.85 172.27C180.68 177.02 179.52 192.01 177.38 197.42C173.75 191.72 171.4 186.92 168.95 174.08L167.6 171.75"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M166.08 169.12L166.07 169.11L166.04 169.06"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M167.6 171.75H167.59"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M176.11 166.94C173.88 167.89 171.7 169.04 169.64 170.35"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M176.15 166.92C176.15 166.92 176.13 166.93 176.12 166.93"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M219.15 95.8401L205.88 109.52"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M215.35 90.2002C217.54 92.6202 220.1 94.9202 222.76 96.8202"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M222.66 96.7402L224.52 94.7302C235.82 88.2702 239.62 84.4902 243.82 79.2202C237.98 78.9602 223.44 82.6902 219.22 85.0102C217.66 87.3202 217.24 87.9802 215.45 90.1002"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M170.3 167.31L159.29 146.25"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M94.67 62.12C93.06 63.15 91.67 64.6701 90.56 66.3301C89.53 67.8801 88.65 69.58 88.18 71.37C86.98 70.3 85.74 69.26 84.46 68.2701C84.46 68.2701 84.4534 68.2667 84.44 68.26C84.31 68.14 84.16 68.0401 84 67.93C82.11 66.47 80.14 65.1201 78.11 63.8801C76.53 63.0101 74.91 62.2401 73.24 61.5801C71.85 61.0201 70.43 60.5401 68.99 60.1301C67.18 59.6201 66.03 59.11 65.6 58.66C65.57 58.63 65.54 58.6 65.52 58.57C65.52 58.57 65.5167 58.5667 65.51 58.5601C65.26 58.1901 65.54 57.9001 66.41 57.7201H66.43C66.58 57.6901 66.74 57.67 66.92 57.64C67.02 57.62 67.12 57.6101 67.23 57.6101C67.63 57.58 68.11 57.56 68.66 57.55H68.68L69.25 57.5401C73.88 57.9101 78.43 58.8101 82.85 60.2201H82.87C85.3 60.1401 81.75 55.33 81.22 53.93C81.12 53.67 81.02 53.41 80.93 53.16H80.96C80.7 52.38 80.54 51.71 80.82 51.58C80.85 51.56 80.89 51.55 80.94 51.55H80.95C81.36 51.58 82.24 52.1801 83.9 53.7701C87.32 56.7701 90.92 59.56 94.67 62.12Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M85.6301 61.1502C84.7201 60.8102 83.8001 60.5002 82.8701 60.2202"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M68.68 57.54H68.65C68.11 57.54 67.63 57.57 67.23 57.61"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M66.9201 57.6401C66.7401 57.6601 66.5801 57.6801 66.4301 57.7201C66.4301 57.7201 66.4235 57.7201 66.4101 57.7201C65.5101 57.8901 65.2201 58.1901 65.5101 58.5601"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M65.52 58.5701C65.52 58.5701 65.56 58.6301 65.59 58.6601H65.6"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M88.2702 71.4501C88.2702 71.4501 88.2102 71.4001 88.1802 71.3701"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M94.7402 62.1701C94.7402 62.1701 94.6902 62.1401 94.6702 62.1201"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M80.9401 51.55C80.8901 51.55 80.8501 51.55 80.8201 51.58C80.5101 51.69 80.6701 52.37 80.9301 53.16"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.72 60.2202H82.85"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M84 67.9301C81.61 66.3501 76.48 65.3101 73.62 64.5001C73.53 64.4701 73.43 64.4501 73.33 64.4201C71.39 63.9101 68.19 63.4701 66.23 62.9601C65.71 62.8201 65.43 61.9101 68.77 61.7201C69.51 61.6801 72.03 61.5501 73.24 61.5801C74.91 62.2401 76.53 63.0101 78.11 63.8801C80.14 65.1201 82.11 66.4701 84 67.9301Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M84.4401 68.2602C82.1701 67.5202 79.7601 66.9802 77.3901 66.6602C75.4201 66.4402 71.9701 66.5302 69.8401 66.3502C69.2901 66.3102 68.8601 65.4202 72.1401 64.7102C72.3501 64.6502 72.8501 64.5302 73.3301 64.4202C73.4301 64.4502 73.5301 64.4702 73.6201 64.5002C76.4801 65.3102 81.6101 66.3502 84.0001 67.9302C84.1601 68.0402 84.3101 68.1402 84.4401 68.2602Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M73.6301 64.3601L73.3301 64.4201"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M98.9101 38.9502C98.4601 37.8102 98.4101 36.5402 98.7801 35.3702C99.0901 34.3702 99.6801 33.5002 100.48 32.8402L100.5 32.8202C100.64 32.7002 100.78 32.5902 100.93 32.4902C100.78 32.6102 100.64 32.7202 100.5 32.8202L100.48 32.8402C100.08 33.1302 99.7101 33.3502 99.3801 33.5002"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M98.1001 31.5602L98.1601 31.5002C98.9701 30.5802 99.5801 29.9202 100.07 29.5002C100.09 29.5002 100.1 29.4802 100.11 29.4602C101.24 28.5302 101.79 28.8402 103.01 30.2802C104.56 32.1002 103.66 35.9602 105.33 38.1502C105.33 38.1602 105.34 38.1602 105.34 38.1702"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M95.15 36.8602C93.78 35.5102 92.44 34.3002 91.78 33.5102C91.56 33.2102 91.46 32.8402 91.51 32.4602C91.56 32.0902 91.75 31.7602 92.04 31.5202C92.34 31.2902 92.71 31.1802 93.08 31.2202C93.45 31.2602 93.8 31.4402 94.04 31.7302C94.87 32.5902 96.13 33.8902 97.15 35.0302C98.5 36.5502 96.65 38.3302 95.15 36.8602Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M99.3801 33.5C99.4901 34.61 98.2201 35.83 97.0801 34.65C95.7101 33.24 94.1501 31.73 93.5201 30.92C93.2801 30.62 93.1801 30.23 93.2301 29.85C93.2801 29.47 93.4801 29.13 93.7901 28.89C94.0901 28.66 94.4801 28.56 94.8601 28.61C95.2401 28.66 95.5901 28.86 95.8201 29.17C96.3401 29.74 97.5801 30.99 98.1001 31.56C97.8801 31.8 97.6401 32.07 97.3901 32.35C96.7201 33.1 97.4401 34.38 99.3801 33.5Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M90.3601 42.1101L90.4401 42.0301L90.4501 42.0201L92.4801 40.0901"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.5002 39.1201H93.4902C92.5502 38.2501 91.8802 37.6701 91.3502 37.1701C91.0902 36.9301 90.8702 36.7101 90.6702 36.4801C90.4502 36.1901 90.3402 35.8301 90.3802 35.4701C90.4202 35.1101 90.5902 34.7801 90.8702 34.5501C91.1502 34.3201 91.5102 34.2001 91.8702 34.2301C92.2302 34.2601 92.5702 34.4301 92.8102 34.7001C93.6402 35.5301 94.4002 36.2501 95.4002 37.3101C96.7402 38.7401 94.9902 40.4901 93.5002 39.1201Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M100.23 64.2101C96.2202 67.2401 93.4802 71.6501 92.5702 76.5901C92.4302 76.4901 92.2902 76.3901 92.1602 76.3001C89.6502 74.4701 87.9102 73.2201 87.9102 73.2201C87.9902 72.6201 88.0202 72.0401 88.1602 71.4501C88.1702 71.4201 88.1702 71.4001 88.1802 71.3701C88.6502 69.5801 89.5302 67.8801 90.5602 66.3301C91.6702 64.6701 93.0602 63.1501 94.6702 62.1201C95.1102 61.8401 95.5702 61.5901 96.0402 61.3901C97.3802 62.2901 98.6601 63.1601 99.8801 63.9701C100 64.0501 100.11 64.1301 100.23 64.2101Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M92.5701 76.6101C92.5701 76.6101 92.5701 76.7201 92.5701 76.7101"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M6.46997 79.0402L10.55 70.4702L23.75 66.0802L28.14 51.9302"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M23.21 54.8201L28.17 51.8501L30.66 57.0501"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M192.06 67.4102L192.61 78.7602"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M198.02 72.8L186.65 73.37"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M59.6101 97.3001C59.6101 99.4201 58.9801 101.5 57.8001 103.26C56.6201 105.02 54.9401 106.4 52.9801 107.21C51.0201 108.02 48.8601 108.24 46.7801 107.82C44.7001 107.41 42.7901 106.38 41.2801 104.88C39.7801 103.38 38.7601 101.47 38.3401 99.38C37.9301 97.3 38.1401 95.14 38.9501 93.18C39.7601 91.22 41.1401 89.5401 42.9001 88.3601C44.6701 87.1801 46.7401 86.55 48.8601 86.55C51.7101 86.55 54.4401 87.6801 56.4501 89.6901C58.4601 91.7001 59.5901 94.43 59.6001 97.28L59.6101 97.3001Z"
          fill="#F3123C"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.62 128.88C80.33 125.94 83.14 122.02 84.74 117.56C85.34 115.46 85.66 113.29 85.7 111.12C86.6 110.85 87.52 110.66 88.47 110.58C92.13 110.24 95.78 111.37 98.61 113.72C101.44 116.07 103.22 119.45 103.57 123.11C103.82 125.84 103.26 128.59 101.95 131C100.64 133.41 98.65 135.38 96.22 136.66C93.79 137.94 91.04 138.47 88.31 138.18C85.58 137.9 83 136.81 80.89 135.06C78.92 133.43 77.45 131.28 76.62 128.87V128.88ZM76.55 128.66C76.32 127.83 76.13 126.98 75.99 126.13C76.08 126.87 76.24 127.62 76.46 128.34C76.49 128.44 76.52 128.55 76.56 128.66H76.55Z"
          fill="#F3123C"
        />
        <Path
          d="M63.34 206.25C61.44 203.22 58.73 200.78 55.53 199.2C55.18 202.78 55.96 206.37 57.76 209.48C59.56 212.59 62.29 215.06 65.57 216.53C65.8 212.96 65.03 209.4 63.34 206.25Z"
          fill="#404040"
        />
        <Path
          d="M84.73 117.56C83.14 122.02 80.32 125.95 76.61 128.89C75.3 124.34 75.3 119.51 76.6 114.95C78.19 110.49 81.01 106.56 84.72 103.62C86.02 108.17 86.03 113 84.73 117.56Z"
          fill="#404040"
        />
        <Path
          d="M43.2999 83.8201C41.8299 82.2901 40.8099 80.3901 40.3599 78.3101C42.4499 78.6801 44.3899 79.6401 45.9599 81.0601C47.4299 82.5901 48.4499 84.5001 48.8999 86.5701C46.8099 86.2001 44.8699 85.2401 43.2999 83.8201Z"
          fill="#404040"
        />
        <Path
          d="M58.9899 158.26C55.5099 155.56 52.2899 152.53 49.3999 149.21C48.4999 152.4 48.1699 155.72 48.4299 159.02C49.1599 164.84 51.4999 170.35 55.1999 174.91C57.9799 169.82 59.2899 164.06 58.9999 158.26H58.9899Z"
          fill="#404040"
        />
        <Path
          d="M59.6101 97.3001C59.6101 99.4201 58.9801 101.5 57.8001 103.26C56.6201 105.02 54.9401 106.4 52.9801 107.21C51.0201 108.02 48.8601 108.24 46.7801 107.82C44.7001 107.41 42.7901 106.38 41.2801 104.88C39.7801 103.38 38.7601 101.47 38.3401 99.38C37.9301 97.3 38.1401 95.14 38.9501 93.18C39.7601 91.22 41.1401 89.5401 42.9001 88.3601C44.6701 87.1801 46.7401 86.55 48.8601 86.55C51.7101 86.55 54.4401 87.6801 56.4501 89.6901C58.4601 91.7001 59.5901 94.43 59.6001 97.28L59.6101 97.3001Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M85.7799 111.1C86.6499 110.84 87.5499 110.67 88.4699 110.58C92.1299 110.24 95.7799 111.37 98.6099 113.72C101.44 116.07 103.22 119.45 103.57 123.11C103.82 125.84 103.26 128.59 101.95 131C100.64 133.41 98.6499 135.38 96.2199 136.66C93.7899 137.94 91.0399 138.47 88.3099 138.18C85.5799 137.9 82.9999 136.81 80.8899 135.06C78.9199 133.43 77.4499 131.29 76.6199 128.88"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M41.71 164.1C47.11 166.39 51.76 170.16 55.13 174.98C49.4 176.26 43.43 175.92 37.89 173.98C32.49 171.68 27.84 167.92 24.47 163.1C30.2 161.82 36.17 162.16 41.71 164.1V164.1Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M63.34 206.25C65.04 209.4 65.81 212.96 65.57 216.53C62.29 215.05 59.56 212.59 57.76 209.48C55.96 206.37 55.18 202.77 55.53 199.2C58.74 200.78 61.45 203.22 63.34 206.25Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.63 130.95C101.37 134.38 97.1999 136.81 92.6199 137.98C93.1199 133.25 95.0999 128.8 98.2699 125.26C101.44 121.72 105.64 119.26 110.29 118.23C109.63 122.91 107.67 127.32 104.64 130.95H104.63Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M84.73 117.56C83.14 122.02 80.32 125.95 76.61 128.89C75.3 124.34 75.3 119.51 76.6 114.95C78.19 110.49 81.01 106.56 84.72 103.62C86.02 108.17 86.03 113 84.73 117.56Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M43.2999 83.8201C41.8299 82.2901 40.8099 80.3901 40.3599 78.3101C42.4499 78.6801 44.3899 79.6401 45.9599 81.0601C47.4299 82.5901 48.4499 84.5001 48.8999 86.5701C46.8099 86.2001 44.8699 85.2401 43.2999 83.8201Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M50.3499 107.94C51.1599 121.28 52.0199 130.13 66.1899 152.04C78.8399 171.6 65.0499 189.73 65.3899 212.35"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.6899 136.39C82.6899 136.39 71.7499 147.33 71.4399 167.51"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M55.1899 174.9C55.1899 174.9 67.4199 182 66.0899 202.04"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M82.3099 215.58C82.0899 214.79 81.5699 214.11 80.8599 213.7C80.1499 213.29 79.2999 213.18 78.5099 213.39L53.1499 220.18C52.7599 220.29 52.3899 220.47 52.0699 220.72C51.7499 220.97 51.4799 221.28 51.2699 221.63C51.0699 221.98 50.9399 222.37 50.8799 222.78C50.8299 223.18 50.8499 223.59 50.9599 223.99C51.0699 224.38 51.2499 224.75 51.4999 225.07C51.7499 225.39 52.0599 225.66 52.4099 225.87C52.7599 226.07 53.1499 226.2 53.5599 226.26C53.9599 226.31 54.3699 226.28 54.7699 226.18L80.1299 219.39C80.9199 219.17 81.5999 218.65 82.0099 217.94C82.4199 217.23 82.5299 216.38 82.3199 215.59L82.3099 215.58Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M51.9701 92.76L47.1701 93.19C46.6301 93.27 46.1501 93.55 45.8101 93.98C45.4701 94.41 45.3101 94.94 45.3601 95.48C45.4101 96.02 45.6601 96.52 46.0701 96.88C46.4801 97.24 47.0001 97.43 47.5501 97.41L50.2301 97.17C50.7701 97.15 51.3001 97.34 51.7101 97.7C52.1201 98.06 52.3701 98.56 52.4201 99.11C52.4701 99.65 52.3101 100.19 51.9701 100.62C51.6301 101.05 51.1401 101.33 50.6001 101.4L45.8001 101.85"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M48.3499 91.49L49.4199 103.12"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M96.01 121.97L90.9 119.05C90.3 118.71 89.59 118.62 88.92 118.8C88.25 118.98 87.68 119.42 87.34 120.02C87 120.62 86.91 121.33 87.09 122C87.27 122.67 87.71 123.24 88.31 123.58L91.16 125.22C91.46 125.39 91.72 125.62 91.93 125.89C92.14 126.16 92.29 126.47 92.39 126.8C92.48 127.13 92.5 127.48 92.46 127.82C92.42 128.16 92.31 128.49 92.14 128.79C91.97 129.09 91.74 129.35 91.47 129.56C91.2 129.77 90.89 129.93 90.56 130.02C90.23 130.11 89.88 130.13 89.54 130.09C89.2 130.05 88.87 129.94 88.57 129.77L83.45 126.85"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M93.28 118.18L86.2 130.62"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M94.7799 197.67C95.5199 197.98 96.3499 197.99 97.0999 197.7C97.8499 197.41 98.4599 196.84 98.7899 196.11C99.1299 195.38 99.1599 194.55 98.8999 193.79C98.6299 193.03 98.0799 192.41 97.3599 192.05L81.5499 184.86C80.8099 184.55 79.9699 184.53 79.2199 184.82C78.4699 185.11 77.8599 185.68 77.5199 186.41C77.1799 187.14 77.1399 187.98 77.4099 188.73C77.6799 189.49 78.2299 190.11 78.9499 190.47L94.7699 197.66L94.7799 197.67Z"
          fill="#F5F5F5"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M130.09 178.84C130.13 179.76 129.91 180.67 129.43 181.46C128.96 182.25 128.26 182.88 127.43 183.27C126.6 183.66 125.67 183.8 124.76 183.67C123.85 183.53 123 183.13 122.32 182.51C121.64 181.89 121.16 181.09 120.93 180.2C120.71 179.31 120.75 178.37 121.06 177.5C121.37 176.63 121.93 175.88 122.67 175.33C123.41 174.78 124.29 174.47 125.21 174.42C125.82 174.39 126.43 174.48 127 174.69C127.58 174.9 128.1 175.21 128.56 175.62C129.01 176.03 129.38 176.52 129.64 177.08C129.9 177.63 130.05 178.23 130.08 178.84H130.09Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M142.65 190.05C142.69 190.97 142.47 191.88 141.99 192.67C141.52 193.46 140.82 194.09 139.99 194.48C139.16 194.87 138.23 195.01 137.32 194.87C136.41 194.74 135.56 194.33 134.88 193.72C134.2 193.1 133.72 192.3 133.49 191.41C133.27 190.52 133.31 189.58 133.62 188.71C133.93 187.84 134.49 187.09 135.23 186.54C135.97 185.99 136.85 185.68 137.77 185.63C138.38 185.6 138.99 185.69 139.56 185.89C140.13 186.1 140.66 186.41 141.12 186.82C141.57 187.23 141.94 187.73 142.2 188.28C142.46 188.83 142.61 189.43 142.64 190.04L142.65 190.05Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M121.61 195.73L141.82 173.43"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M58.9 157.39C58.07 151.81 55.75 146.55 52.2 142.16C49.38 147.31 48.07 153.15 48.42 159.01C49.15 164.83 51.49 170.34 55.19 174.9C58.15 169.56 59.44 163.47 58.9 157.39Z"
          stroke="#2E2E2E"
          strokeWidth={0.94}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_8483_162413">
          <Rect width={238.29} height={202.74} fill="white" transform="translate(6 24)" />
        </ClipPath>
      </Defs>
    </Svg>
  </Box>
)
